<template>
  <div class="vote">
    <div class="vote_head">
      <img src="../assets/1.jpg" alt="">
      <div class="vote_box">
        <!-- <div class="vote_title">投票排名</div> -->
        <!-- <div class="vote_rules">投票规则</div> -->
        <div class="rules_box">
          <div style="background:rgba(255,255,255,0.6)">
            <img style="width:100%;height:auto" src="../assets/promotionList/top.jpg" alt="">
            <div class="player_box_inner">
              <div v-for="(item,index) in list" :key='item.Id' class="player">
                <div class="player_content" v-if="index < 5">
                  <div class="Content_img" @click="getMember(item.Id)">
                    <img class="IsImg" :src="item.Photo?item.RootPath+item.Photo:'/static/img/暂无头像.807e212.jpg'" alt="">
                    <!-- <span class="Serial">编号:{{item.No}}</span> -->
                  </div>
                  <div class="name">{{item.UserName}}</div>
                  <div style="color: #FF0000;font-size: 14px;font-weight:bold">{{item.VoteCnt}}票</div>
                  <!-- <el-button :disabled="isdisabled" size='mini' @click="isimgMat = !isimgMat" class="vote_btn" type="primary">投票</el-button> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="rules_box_inner">
            <p v-for="(item,index) in VoteRules" :key="item">{{index+1}}、{{item}}</p>
          </div> -->
        </div>
      </div>
    </div>
    <div class="player_list">
      <div class="player_box">
        <div class="player_header">
          <div class="player_line"></div>
          <div class="text_Center">投票</div>
        </div>
        <div v-if="list.length < 0" style="color: #333;text-align: center;padding: 20px 0;">投票暂未开始</div>
        <div class="vote_search"  v-if="list.length > 0">
          <div>今日剩余票数：{{VoteCnt}}票</div>
          <div>
            <el-input v-model="name" style="border-radius: 30px; overflow: hidden;" placeholder="请输入姓名或编号" class="input-with-select">
              <el-button slot="append" @click="searchFun" icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
        <div class="player_box_inner"  v-if="list.length > 0">
          <div v-for="(item,index) in list" :key='item.Id' class="player">
            <div class="player_content">
              <div class="Content_img" @click="getMember(item.Id)">
                <img class="IsImg" :src="item.Photo?item.RootPath+item.Photo:'/static/img/暂无头像.807e212.jpg'" alt="">
                <span class="Serial">编号:{{item.No}}</span>
              </div>
              <div class="name">{{item.UserName}}</div>
              <div style="color: #FF0000;font-size: 14px;margin-bottom: 10px;">{{item.VoteCnt}}票</div>
              <el-button :disabled="isdisabled" size='mini' @click="isimgMat = !isimgMat" class="vote_btn" type="primary">投票</el-button>
            </div>
          </div>
        </div>
        <div style="text-align: center;padding: 20px 0;"  v-if="list.length > 0">
          <el-pagination background layout="prev, pager, next" :page-size="20" :total="TotalItem" @current-change="handleSizeChange"
            :current-page.sync="pageIndex">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="imgMat" v-if="isimgMat">
      <img src="../assets/code.png" @click="isimgMat = !isimgMat" alt="">
    </div>
    <el-dialog title="选手信息" :visible.sync="dialogTableVisible">
      <div class="dialog_img">
        <img :src="data.RootPath+data.Photo">
      </div>
      <p class="content_list">姓名:{{data.UserName}}</p>
      <p class="content_list">宣言:{{data.Declaration}}</p>
      <p class="content_list">持证类型:{{data.CertIds}}</p>

      <p class="content_list">从业时间:{{data.WorkingStart}}年</p>
      <p class="content_list">所在地区:{{data.ProvinceName}}-{{data.CityName}}</p>
    </el-dialog>
    <v-login v-on:guanbi='guanbi' v-on:bindSuccess='bindSuccess' v-if="login"></v-login>
  </div>

</template>

<script>
  import vLogin from '@/components/common/login'
  export default {
    data() {
      return {
        current: 1,
        list: [],
        isimgMat:0,
        login:0,
        isdisabled:false,
        name: '',
        color: ["#12A3EA", "#FF0000", "#e91e63", "#5b1ee9", "#1ee925", "#9c27b0", "#12A3EA", "#FF0000", "#409EFF"],
        a_idx: 0,
        pageIndex: 1,
        pageSize: 20,
        TotalItem: 0,
        VoteRules: [],
        data: [],
        dialogTableVisible: false,
        VoteCnt: 0,
      };
    },
    created() {
      this.getVoteRules()
      this.getCompetitionUsers()
      localStorage.getItem('competition_cookie')?this.VoteFrequency():""
    },
    methods: {
      getVoteRules: function() {
        this.axios.get('/api/SiteSetting/GetVoteRules')
          .then(res => {
            this.VoteRules = res.data.data.Rule
          })
      },
      bindSuccess:function(guanbi){
      	this.login = guanbi
      },
      guanbi:function(guanbi){
      	this.login = guanbi
      },
      VoteFrequency: function() {
        this.axios.get('/api/Vote/VoteFrequency')
          .then(res => {
            console.log(res)
            this.VoteCnt = res.data.data
          })
      },
      handleSizeChange: function() {
        console.log(this.pageIndex)
        this.getCompetitionUsers()
      },
      getCompetitionUsers: function() {
        this.axios.get('/api/Vote/GetCompetitionUsers?name=' + this.name + '&pageIndex=' + this.pageIndex +
            '&pageSize=' + this.pageSize)
          .then(res => {
            console.log(res)
            this.list = res.data.data?res.data.data:[]
            this.TotalItem = res.data.TotalItem
          })
      },
      getMember: function(Id) {
        this.axios.get('/api/Vote/GetMember?Id=' + Id).then(res => {
          console.log(res)
          this.data = res.data.data
          this.dialogTableVisible = true
        })
      },
      searchFun: function() {
        this.pageIndex = 1
        this.getCompetitionUsers()
      }
    },
    components: {vLogin}
  }
</script>

<style scoped="scoped" lang="scss">
  .praise {
    z-index: 99999;
    top: y-20;
    left: x;
    position: absolute;
    color: #12A3EA;
    font-weight: 700;
    font-family: hyllh
  }
  .imgMat{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 999;
    top: 0;left: 0;
    img{
      position: absolute;top: 0;left: 0;right: 0;bottom: 0;margin: auto;
    }
  }
  .vote {
    width: 100%;

    .content_list {
      font-size: 16px;
      margin-bottom: 25px;
    }

    .dialog_img {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      margin-bottom: 25px;
      overflow: hidden;

      img {
        width: 140px;
      }
    }

    .vote_head {
      overflow: hidden;
      background-size: cover;
      text-align: center;
      position: relative;

      img {
        width: 100%;
        height: 800px;
        perspective: 100px
      }

      .vote_box {
        position: absolute;
        top: 0;
        width: 100%;
        bottom: 0;
        margin: auto;

        .vote_title {
          font-size: 40px;
          color: #fff3ab;
          text-shadow: 0px 0px 5px #fff3ab;
          font-weight: bold;
          margin: 50px 0 30px 0;
        }

        .vote_rules {
          color: #fff3ab;
        }

        .rules_box {
          width: 900px;
          line-height: 35px;
          margin: 180px auto;
          // margin-top: 30px;
          padding: 20px;
          box-sizing: border-box;
          border-radius: 5px;
          background: rgba(255, 255, 255, .5);
          .player_box_inner {
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 20px;
        }

        .player {
          width: 20%;
          // background: #fff;

          .player_content {
            width: 150px;
            margin: 0 auto;
            // margin-bottom: 20px;
            text-align: center;
            line-height: normal;
            .Content_img {
              width: 140px;
              height: 180px;
              background: #fff;
              // border-radius: 50%;
              overflow: hidden;
              box-shadow: 0px 0px 12px #666;
              margin: 0 auto;
              position:relative;
              .IsImg {
                width: 100%;
                height: auto;
              }
            }

            .name {
              color: #666;
              font-size: 16px;
              padding: 12px 0 5px 0;
            }
          }
        }
          .rules_box_inner {
            padding: 10px 60px;
            box-sizing: border-box;
            background: rgba(255, 255, 255, .5);
            width: 100%;
            height: 100%;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            p {
              color: #3E1976;
              text-align: left;
              margin-bottom: 20px;
            }
          }
        }
      }
    }

    .player_list {
      padding: 50px 0;
      background: #eee;

      .player_box {
        width: 900px;
        background: #fff;
        margin: 0 auto;
        border-radius: 3px;
        box-shadow: 0px 0px 10px #bbb;
        overflow: hidden;

        .vote_search {
          display: flex;
          color: #000;
          padding: 0 20px;
          font-size: 14px;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;

        }

        .player_header {
          width: 100%;
          height: 50px;
          position: relative;
          padding: 0 20px;
          margin-top: 20px;
          box-sizing: border-box;

          .text_Center {
            width: 100px;
            height: 50px;
            line-height: 50px;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            color: #3E1976;
            background: #fff;
            text-align: center;
            font-size: 26px;
            font-weight: bold;
          }

          .player_line {
            width: calc(100% - 40px);
            height: 1px;
            background: #3E1976;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
          }

        }

        .player_box_inner {
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 20px;
        }

        .player {
          width: 20%;
          background: #fff;

          .player_content {
            width: 150px;
            margin: 0 auto;
            margin-bottom: 20px;
            text-align: center;

            .vote_btn {
              border-radius: 30px;
              width: 80px;
              background: #fdcb00;
              border-color: #fdcb00;
              position: relative;
              box-shadow: 3px 4px 2px #2e00c2;
            }

            .Content_img {
              width: 140px;
              height: 140px;
              background: #fff;
              border-radius: 50%;
              overflow: hidden;
              box-shadow: 1px 2px 3px #333;
              margin: 0 auto;
              position:relative;
              .Serial{
                position: absolute;
                text-align: center;
                bottom: 0;
                width: 100%;
                height: 20px;
                text-align: center;
                left: 0;
                font-size: 12px;
                line-height: 20px;
                background: rgba(0, 0, 0, .5);

              }
              .IsImg {
                width: 140px;
                ;
              }
            }

            .name {
              color: #666;
              font-size: 16px;
              padding: 10px 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vote.vue